import(/* webpackMode: "eager" */ "/vercel/path0/apps/thesiadgroup/src/app/[locale]/template.tsx");
